// import
import { gsap } from "gsap";
    
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";

gsap.registerPlugin(ScrollTrigger, CustomEase);

// Global VAR
const customEase = CustomEase.create("custom", "0.45, 0.02, 0.09, 0.98");
const duration = 0.4;
const delayedDuration = 0.6;
const isMobile = window.innerWidth <= 960

// Teaser anim
const teaser = document.querySelector(".teaser")

if ( teaser && !isMobile) {
  let teaserTranslate = -16

  if (teaser.classList.contains("right")) {
    teaserTranslate = 16;
  }

  gsap.from(".teaser-image-container", {
    scrollTrigger: {
      trigger: ".teaser-image",
      start: "top bottom",
    },
    x: teaserTranslate,
    opacity: 0,
    duration: duration,
    ease: customEase
  })
}

//Footer anim 
gsap.fromTo(".footer-shape", 
  { y: 128 },
  {
    y: -50,
    scrollTrigger: {
      trigger: "footer",
      start: "top bottom",
      end: "bottom bottom",
      scrub: true,
    },
  }
)

// Contact form anim
const contactForm = document.querySelector(".form-contact")

if ( contactForm) {
  gsap.from(contactForm, {
    y: 32,
    opacity: 0,
    duration: duration,
    ease: customEase
  })
}

// contact form appointement shapes anim
const rdvForm = document.querySelector(".form-rdv")

if(rdvForm && !isMobile) {
  gsap.from(rdvForm, {
    scrollTrigger: {
      trigger: rdvForm,
      start: "top bottom",
    },
    y: 32,
    opacity: 0,
    duration: duration,
    ease: customEase
  })

  let rdvTl = gsap.timeline({
    scrollTrigger: {
      trigger: rdvForm,
      start: "70% bottom",
    }
  })

  rdvTl.from(".form-rdv-shape-bright", {
    y: "66%",
    duration: .6,
    ease: customEase
  })

  rdvTl.from(".form-rdv-shape-dark", {
    y: "100%", 
    duration: .7,
    ease: customEase
  }, "<0.075")
}

// Stagger elements
gsap.utils.toArray(".stagger-container").forEach((container) => {
  const elements = container.querySelectorAll(".stagger-element");
  
  gsap.from(elements, {
    scrollTrigger: {
      trigger: container,
      start: "top 95%",
    },
    y: 12,
    opacity: 0,
    stagger: 0.1,
    duration: duration,
    ease: customEase
  });

  elements.forEach(element => {
    let hoverAnim = gsap.to(element, {
      paused: true,
      scale: 1.015,
      duration: duration,
      ease: customEase
    })

    element.addEventListener("mouseenter", () => hoverAnim.play())
    element.addEventListener("mouseleave", () => hoverAnim.reverse())
  });
});

// Image shape
const images = document.querySelectorAll(".image")

images.forEach((image) => {
  if ( image.classList.contains("background") ) {
    let backgroundTranslate = "-110%";
    const imgBackground = image.querySelector(".image-background")

    if (image.classList.contains("right")) {
      backgroundTranslate = "110%";
    }

    gsap.from(imgBackground, {
      scrollTrigger: {
        trigger: image,
        start: "-5% bottom",
      },
      x: backgroundTranslate,
      duration: .6,
      ease: customEase
    })
  }
})

// Hero anim 
const hero = document.querySelector(".hero-title-image.gsap")
const heroTitle = hero?.querySelector(".hero-title")

if (hero) {
  const tl = gsap.timeline()

  tl.from(hero, {
    opacity: 0,
    duration: duration,
    ease: customEase
  })
    tl.from(hero, {
    clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
    duration: delayedDuration + 0.2,
    ease: customEase
  }, "<")

  tl.from(".hero-image", {
    scale: 1.02,
    duration: delayedDuration,
    ease: customEase
  }, "<")

  if (heroTitle) {
    tl.from(".hero-title", {
      opacity: 0.2,
      y: 8,
      duration: duration,
      ease: customEase
    }, "<0.2")
  }
}

// header anims
gsap.from("header", {
  y: -24,
  opacity: 0,
  duration: delayedDuration,
  ease: customEase,
})

let isMenuOpen = false

gsap.to("header", {
  ease: customEase,
  scrollTrigger: {
    start: "top top",
    end: "bottom bottom",
    onUpdate: self => {
      const scrollTop = window.scrollY;

      if (scrollTop === 0) {
        gsap.set("header", { y: 0 });
        return;
      }

      if (self.direction === 1) {
        gsap.to("header", { y: "-150%", duration: delayedDuration });
      } else {
        gsap.to("header", { y: "0%", duration });
      }
    }
  }
});

document.querySelector(".menu-button").addEventListener("click", () => {
  isMenuOpen = !isMenuOpen

  if (isMenuOpen) {
    gsap.from(".menu-item", {
      opacity: 0,
      y: 10,
      duration: duration,
      stagger: 0.075,
      delay: 0,
      ease: customEase
    })
  }
})

// Number highlights
gsap.utils.toArray(".number-highlights-container").forEach((container) => {
  const options = {
    yPercent: 100,
    opacity: 0,
    ease: customEase,
  }

  if (window.innerWidth < 768) {
    container.querySelectorAll(".number-highlight").forEach((highlight) => {
      gsap.from(highlight.querySelector(".number-highlight-value"), {
        scrollTrigger: {
          trigger: highlight,
          start: "70% bottom",
        },
        ...options
      })
    })
  } else {
    gsap.from(container.querySelectorAll(".number-highlight-value"), {
      scrollTrigger: {
        trigger: container,
        start: "70% bottom",
      },
      ...options,
      stagger: 0.1,
    })
  }
})

// Gallery
gsap.from(".gallery-button", {
  scrollTrigger: {
    trigger: ".gallery-button",
    start: "top bottom",
  },
  opacity: 0,
  y: 20,
  duration,
  ease: customEase,
})
